<template>
  <span>
    <span class="ft-12"
      >商品资料已维护套图，电商平台图片可以使用已维护套图快速填充 <el-link @click="editGroupImages">维护套图</el-link></span
    >
    <GroupImagesList :baseItemId="TmStep3.baseItemId" :hideImgs="['detailImages']" :specifications="specifications" @useOk="useGroupImages" @getList="getGroupImagesList"></GroupImagesList>
  </span>
</template>

<script>
import GroupImagesList from '@/components/prod/center/BasicComps/GroupImages/list.vue';

export default {
  components: {
    GroupImagesList,
  },
  inject: ['TmStep3'],
  props: ["props", "form"],
  computed: {
    key() {
      return this.props.name;
    },
    specifications() {
      return this.TmStep3?.$refs?.sku?.length ? this.TmStep3?.$refs?.sku[0]?.specifications : []
    },
  },
  methods: {
    useGroupImages(data, type) {
      const { mainImages = [], speImages = [] } = data;
      const groupMainImages34 = data?.mainImages34 || []
      let pic = [], mainImages34= [];
      if (type === 'add') {
        pic = [...this.form.item_images].filter(Boolean);
        mainImages34 = [...this.form.three_to_four_item_images].filter(Boolean);
      }
      if(mainImages.length) {
        this.form.item_images = [...pic, ...mainImages].filter(Boolean).slice(0, 5)
      }
      if(groupMainImages34.length) {
        this.form.three_to_four_item_images = [...mainImages34, ...groupMainImages34].filter(Boolean).slice(0, 5)
      }
      const specificationsRef = this.TmStep3.$refs.sku;
      if(specificationsRef && speImages.length) {
        const firstSpec = specificationsRef[0]?.specifications[0];
        if (firstSpec && firstSpec.values) {
          firstSpec.values.forEach(specValue => {
            // 如果是新增模式且已有图片，则跳过
            if (type === 'add' && specValue.imageUrl) {
              return;
            }
            
            // 查找匹配的图片
            const matchedImage = speImages.find(img => img.name === specValue.value);
            if (matchedImage) {
              specValue.imageUrl = matchedImage.imgUrl;
            }
          });
        }
      }
    },
    getGroupImagesList(list) {
      this.form.showGroupImages = !!list?.length
    },
    editGroupImages() {
      this.TmStep3.changeToBase('openGroupImgs');
    },
  },
};
</script>

<style lang="scss" scoped>
</style>